var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 885,
    height: 578,
    viewBox: "0 0 885 578",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M878.656 1018.66C936.757 268.874 523.596 90.8807 255.172 0.300603L-401.2 282.632L-331.672 1119.25L878.656 1018.66Z",
    fill: "url(#paint0_radial_4016_57788)",
    fillOpacity: 0.85
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4016_57788",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(254 9.99998) rotate(55.9688) scale(955.072 1107.35)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C52CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572917,
    stopColor: "#001F5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B43FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerLogo);
export default __webpack_public_path__ + "static/media/bannerLogo.e596ee159cc89bd727a8828b77ee2330.svg";
export { ForwardRef as ReactComponent };